import clsx from "clsx";
import Button from "../../student/components/generic/button";
import { useLocation } from "react-router-dom";

export interface TabbedNavChoice {
  text: string;
  href: string;
}

export const TabbedNav: React.FC<{ choices: TabbedNavChoice[] }> = ({
  choices,
}) => {
  const { pathname } = useLocation();

  return (
    <ul className="flex gap-6">
      {choices.map(({ text, href }) => {
        const isActive = pathname.endsWith(href.replace(/^\.+/, ""));
        return (
          <li key={href}>
            <Button
              className={clsx(isActive ? "!px-4" : "")}
              href={href}
              type={isActive ? "primary" : "link"}
            >
              {text}
            </Button>
          </li>
        );
      })}
    </ul>
  );
};
